// src/pages/CookiePolicy.jsx
import React from "react";
import { Container, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const CookiePolicy = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        backgroundImage: `url(${require("../assets/images/landing_background.jpg")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        fontFamily: "'Baloo Bhaijaan 2', cursive",
        color: "white",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <header
        style={{
          width: "100%",
          padding: "10px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.5)",
        }}
      >
        <img
          src={require("../assets/images/logo_name.PNG")}
          alt="YourStoryWorld Logo"
          style={{ height: "40px", cursor: "pointer" }}
          onClick={() => navigate("/")}
        />
        <div>
          <Button color="inherit" onClick={() => navigate("/")}>
            Home
          </Button>
          <Button color="inherit" onClick={() => navigate("/login")}>
            Sign In
          </Button>
          <Button color="inherit" onClick={() => navigate("/help")}>
            Help
          </Button>
        </div>
      </header>

      {/* Content */}
      <Container
        maxWidth="md"
        style={{
          marginTop: "30px",
          marginBottom: "30px",
          background: "rgba(255, 255, 255, 0.97)",
          borderRadius: "10px",
          padding: "30px 20px",
          color: "#333",
        }}
      >
        <Typography variant="h4" gutterBottom>
          Cookie Policy
        </Typography>
        <Typography variant="subtitle2" gutterBottom>
          Last Updated: December 2025
        </Typography>
        <Typography variant="body2" paragraph>
          This Cookie Policy explains how YourStoryWorld Ltd (Company No. 17098564) uses cookies and similar
          technologies on our website and apps.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. What are cookies?
        </Typography>
        <Typography variant="body2" paragraph>
          Cookies are small text files stored on your device when you visit a
          website. They help the site remember your actions and preferences so
          you don’t have to re-enter them every time you return.
        </Typography>

        <Typography variant="h6" gutterBottom>
          2. Types of cookies we use
        </Typography>
        <Typography variant="body2" paragraph>
          We use the following categories of cookies:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2">
              <strong>Strictly necessary cookies:</strong> required for the site
              to function (e.g. login, security, session management). These
              cannot be switched off in our systems and do not require consent.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              <strong>Preference cookies:</strong> remember choices such as
              language, reading settings or region to improve your experience.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              <strong>Analytics cookies:</strong> help us understand how the
              platform is used (for example, which pages are most popular) so we
              can improve the service. Data is generally aggregated and
              anonymised.
            </Typography>
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          3. Cookies and children
        </Typography>
        <Typography variant="body2" paragraph>
          YourStoryWorld is designed for children, but cookie choices are
          managed by adults (parents, carers, schools). We do not use cookies to
          deliver behavioural advertising to children or to track them across
          unrelated websites.
        </Typography>

        <Typography variant="h6" gutterBottom>
          4. Managing cookies
        </Typography>
        <Typography variant="body2" paragraph>
          When you first visit our site, you will see a cookie banner asking you
          to make a choice. You can:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2">
              Accept only essential cookies (required for the site to work), or
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Accept all cookies, including optional analytics and preferences.
            </Typography>
          </li>
        </ul>
        <Typography variant="body2" paragraph>
          You can also adjust your browser settings to block or delete cookies,
          but some features of the platform may not work correctly if you do.
        </Typography>

        <Typography variant="h6" gutterBottom>
          5. Third-party cookies
        </Typography>
        <Typography variant="body2" paragraph>
          Some cookies may be placed by third-party services we use, such as
          analytics tools or payment providers. These providers have their own
          privacy and cookie policies, which we recommend you review.
        </Typography>

        <Typography variant="h6" gutterBottom>
          6. Updates to this policy
        </Typography>
        <Typography variant="body2" paragraph>
          We may update this Cookie Policy from time to time, for example if we
          introduce new technologies or services. The latest version will always
          be available on this page.
        </Typography>

        <Typography variant="h6" gutterBottom>
          7. Contact
        </Typography>
        <Typography variant="body2" paragraph>
          If you have questions about our use of cookies, please contact:
          <br />
          <strong>support@yourstoryworld.com</strong>
        </Typography>
      </Container>
    </div>
  );
};

export default CookiePolicy;
